import gql from 'graphql-tag';

export const CACHE_RESET = gql`
  mutation CacheReset($scope: Str, $urlPattern: Str, $urls: [Str]) {
    cacheReset(input: { scope: $scope, urlPattern: $urlPattern, urls: $urls }) {
      success
      errors
    }
  }
`;
